import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { layoutSetCurrentPraticaState } from "layout/_redux/actions";
import {
	layoutEndStepSelector,
	layoutHigherIndexStepSelector,
	layoutStepsSelector,
} from "layout/_redux/selectors";
import BftStepper from "layout/components/stepper";
import { getIconStepStyle } from "layout/helpers/utils";
import { reopenEndStepSelector } from "pages/reopened/_redux/selector";
import React, { useEffect } from "react";
import { Accordion } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import MacroStep from "./macro-step";

const VerticalStepper: React.FC = () => {
	const location = useLocation();
	const dispatch = useAppDispatch();

	const steps = useAppSelector(layoutStepsSelector);
	const layoutEndStep = useAppSelector(layoutEndStepSelector);
	const reopenEndStep = useAppSelector(reopenEndStepSelector);
	const higherStepIndex = useAppSelector(layoutHigherIndexStepSelector);

	const currentStep = steps?.find(
		(s) => s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
	);

	const currentStepIndex =
		steps
			?.filter((s) => !s?.hideOnMenu)
			?.findIndex(
				(s) =>
					s.route == location.pathname || s?.subSteps?.find((ss) => ss?.route == location.pathname)
			) || 0;

	const currentSubstep = currentStep?.subSteps?.find((ss) => ss.route == location.pathname);

	const currentSubstepIndex = currentStep?.subSteps?.findIndex(
		(ss) => ss.route == location.pathname
	);

	useEffect(() => {
		if (currentStep) {
			dispatch(layoutSetCurrentPraticaState([currentStep]));
		}
	}, [currentStep]);

	return (
		<Accordion activeKey={String(currentStepIndex)}>
			{steps
				?.filter((s) => !s?.hideOnMenu)
				?.map((step, index) => {
					return (
						<div key={`step_${index}`}>
							<MacroStep
								route={step?.route}
								title={step?.title}
								subtitle={step?.subtitle}
								icon={step?.icon}
								iconStyle={getIconStepStyle(currentStepIndex, index, layoutEndStep)}
								isCompleted={
									layoutEndStep || reopenEndStep || currentStepIndex > steps.indexOf(step)
								}
								isCliccable={steps.indexOf(step) <= higherStepIndex}
							/>

							<Accordion.Collapse eventKey={String(index)} className="pb-4">
								<BftStepper
									type="substep"
									orientation="vertical"
									steps={step?.subSteps}
									activeStep={currentSubstep}
									activeStepIndex={currentSubstepIndex}
								/>
							</Accordion.Collapse>
						</div>
					);
				})}
		</Accordion>
	);
};

export default VerticalStepper;
